import React, { Fragment, useEffect, useState } from 'react';
import './myfavorite.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getFavoriteRecipes, getRecipeNutritions, removeFavRecipes, getPlatingImages, getPackagingImages } from '../../Redux/ActionCreators/homepageAction';
import { Accordion } from 'react-bootstrap';
import TablePagination from '../../utils/tablePagination';
import Lightbox from '../../utils/lightBox';


export default function FavoriteRecipes() {
    const [active, setActive] = useState('-1');
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [openBox, setOpenBox] = useState(false);
    const [image, setImage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingPlateImg, setIsLoadingPlateImage] = useState(false);
    const [isLoadingPkgImg, setIsLoadingPkgImage] = useState(false);

    const dispatch = useDispatch();
    const { favRecipes } = useSelector(state => state.home);

    useEffect(() => {
        dispatch(getFavoriteRecipes(1, ''))
    }, [])

    const searchKeyword = async () => {
        setPage(1);
        await dispatch(getFavoriteRecipes(1, search));
    }

    const resetkeyword = async () => {
        setSearch('');
        await dispatch(getFavoriteRecipes(1, ''));
    }

    const removeFavorites = async (rid, id) => {
        let obj = {
            "recipeId": rid,
            "isFavorite": false
        }
        await dispatch(removeFavRecipes(obj, id));
    }

    const handleAccordion = (i) => {
        if (Number(active) === i) {
            setActive(-1);
        } else {
            setActive(i);
        }
    }

    const openImage = (e, img) => {
        e.preventDefault();
        e.stopPropagation();
        setOpenBox(true);
        setImage(img)
    }

    const goToPrev = () => {
        setPage(page - 1);
        dispatch(getFavoriteRecipes(page - 1, search));
    }

    const goToNext = () => {
        setPage(page + 1);
        dispatch(getFavoriteRecipes(page + 1, search));
    }

    const getRecipeNutrition = async (detail, i) => {
        await setIsLoading(true);
        await dispatch(getRecipeNutritions(detail, i, 'favorite'));
        await setIsLoading(false);
    }

    const getPlatingImage = async (detail, i) => {
        await setIsLoadingPlateImage(true);
        await dispatch(getPlatingImages(detail, i, 'favorite'));
        await setIsLoadingPlateImage(false);
    }

    const getPackagingImage = async (detail, i) => {
        await setIsLoadingPkgImage(true);
        await dispatch(getPackagingImages(detail, i, 'favorite'));
        await setIsLoadingPkgImage(false);
    }

    return (

        <div className='favorite-recipes'>
            <h2 className="d-flex">
                Favorite Recipes
            </h2>
            {favRecipes &&
                <div className='fav-header'>
                    <div className='fav-input'>
                        <input type='search' placeholder='Search By Name' value={search} className='form-control' onChange={(e) => setSearch(e.target.value)} />
                        <button onClick={searchKeyword} disabled={!search}> <img src='./svg-icons/search-icon.svg' width={20} alt='' /> &nbsp;Search</button>&nbsp;&nbsp;
                        <button onClick={resetkeyword} disabled={!search} className='btn-secondary'> Clear</button>
                    </div>
                </div>}
            < div className='content-holder' >
                <div className='content'>
                    <Accordion defaultActiveKey={`${active}`} id='accord' >
                        {
                            favRecipes?.rows?.map((el, i) => {
                                return (
                                    <Accordion.Item key={i} eventKey={`${i}`}>
                                        <Accordion.Header className={Number(active) === i ? 'active-acc' : ''} onClick={() => handleAccordion(i)}>
                                            <div className='d-flex justify-content-between w-100 flex-wrap' style={{ background: Number(active) === i ? '#F3FBFD' : '' }}>
                                                <div className={window.innerWidth > 767 ? 'w-50' : 'w-100'}>
                                                    <h2 className='d-flex justify-content-between align-items-center'>{el.recipe.data?.recipe_name}
                                                        <img src='./svg-icons/heart-filled.svg' className='mt-15' alt='' onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            removeFavorites(el.recipe?.id, el.id);
                                                        }} />
                                                    </h2>
                                                    <h4>({el.recipe.data.serving_size} Servings, {el.recipe.data.shelf_life} Shelf-life)</h4>
                                                    {window.innerWidth < 767 &&
                                                        <div className='recipe-img-box'>
                                                            <img src={el.recipe.data.recipe_image || '/images/placeholder-image.gif'} alt='' className='recipe-img' />
                                                        </div>
                                                    }
                                                    <div className='mt-4'>
                                                        {
                                                            el.recipe.data.ingredients && (
                                                                <div>
                                                                    <h3>Ingredients:</h3>
                                                                    <p dangerouslySetInnerHTML={{ __html: el.recipe.data.ingredients.replaceAll("\n", "<br>") }}></p>
                                                                </div>
                                                            )
                                                        }
                                                    </div>

                                                </div>
                                                {window.innerWidth > 767 ?
                                                    <div className={window.innerWidth > 767 ? 'w-50' : 'w-100'}>
                                                        <div className='recipe-img-box'>
                                                            <img src={el.recipe.data.recipe_image || '/images/placeholder-image.gif'} alt='' className='recipe-img' onClick={(e) => window.innerWidth > 767 ? openImage(e, el.recipe.data.recipe_image) : null} />
                                                        </div>
                                                    </div> :
                                                    null
                                                }
                                            </div>

                                        </Accordion.Header>
                                        <Accordion.Body className={Number(active) === i ? 'active-acc-body' : ''}>
                                            <div className='row'>
                                                <div className='col-md-6 col-12'>
                                                    <div className='mt-4'>
                                                        {
                                                            el.recipe.data.other_ingredients && (
                                                                <div className='mt-2'>
                                                                    <h3>Other Ingredients:</h3>
                                                                    <p dangerouslySetInnerHTML={{ __html: el.recipe.data.other_ingredients.replaceAll("\n", "<br>") }}></p>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                    <div className='mt-4'>
                                                        {
                                                            el.recipe.data.instructions && (
                                                                <div>
                                                                    <h3>Instructions:</h3>
                                                                    <p dangerouslySetInnerHTML={{ __html: el.recipe.data.instructions.replaceAll("\n", "<br>") }}></p>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                    <div className='mt-4'>
                                                        {
                                                            el.recipe.data.bacteria_removal_procedures && (
                                                                <div>
                                                                    <h3>Bacteria Removal Procedures:</h3>
                                                                    <p dangerouslySetInnerHTML={{ __html: el.recipe.data.bacteria_removal_procedures.replaceAll("\n", "<br>") }}></p>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                    <div className='mt-4'>
                                                        {
                                                            el.recipe.data.safe_handling && (
                                                                <div>
                                                                    <h3>Safe Handling:</h3>
                                                                    <p dangerouslySetInnerHTML={{ __html: el.recipe.data.safe_handling.replaceAll("\n", "<br>") }}></p>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                    <div className='mt-4'>
                                                        {
                                                            el.recipe.data.optimization_efficiencies && (
                                                                <div>
                                                                    <h3>Optimization & Efficiencies:</h3>
                                                                    <p dangerouslySetInnerHTML={{ __html: el.recipe.data.optimization_efficiencies.replaceAll("\n", "<br>") }}></p>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                    <div className='mt-4'>
                                                        {
                                                            (
                                                                <div>
                                                                    <h3>Packaging :</h3>
                                                                    {el.recipe.data.material_methodology &&
                                                                        <div className='mt-3'>
                                                                            <h3>Material & Methodology</h3>
                                                                            <p dangerouslySetInnerHTML={{ __html: el.recipe.data.material_methodology.replaceAll("\n", "<br>") }}></p>
                                                                        </div>
                                                                    }
                                                                    {el.recipe.data.product_package_dimensions &&
                                                                        <div className='mt-3'>
                                                                            <h3>Product & Package Dimensions</h3>
                                                                            <p dangerouslySetInnerHTML={{ __html: el.recipe.data.product_package_dimensions.replaceAll("\n", "<br>") }}></p>
                                                                        </div>
                                                                    }
                                                                    {el.recipe.data.package_wrap_labeling &&
                                                                        <div className='mt-3'>
                                                                            <h3>Package Wrap Labeling</h3>
                                                                            <p>
                                                                                {el.recipe.data?.package_wrap_labeling.map(item => <div key={item}>{item}</div>)}
                                                                            </p>
                                                                            {!el?.packageWrapImages?.length ?
                                                                                <div className='view-img'>
                                                                                    <button onClick={() => getPackagingImage(el?.recipe?.data, i)} disabled={isLoadingPkgImg}>{isLoadingPkgImg ? 'Loading Images ...' : 'View Images'}</button>
                                                                                </div> :
                                                                                null
                                                                            }
                                                                            {el?.packageWrapImages?.length ?
                                                                                <div className='d-flex flex-wrap'>
                                                                                    {el?.packageWrapImages?.map((image, index) => {
                                                                                        return (
                                                                                            <div key={index} className={(window.innerWidth > 767 ? 'col-md-2 col-6 ps-0 padd mt-2' : 'col-md-2 col-6 ps-0 padd1 mt-2')} >
                                                                                                <img src={image} alt='' className='plating-img' onClick={(e) => window.innerWidth > 767 ? openImage(e, image) : null} />
                                                                                            </div>
                                                                                        )
                                                                                    })}
                                                                                </div>
                                                                                :
                                                                                null
                                                                            }

                                                                        </div>
                                                                    }

                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                                <div className='recipe-right col-md-6 col-12'>
                                                    <div className='mt-4'>
                                                        {el.recipe.data?.nutrition_facts && (
                                                            <div>
                                                                <h3>Nutrition Facts:</h3>
                                                                <p dangerouslySetInnerHTML={{ __html: el.recipe.data.nutrition_facts.replaceAll("\n", "<br>") }}></p>

                                                                {el.recipe.data?.references_sources && (
                                                                    <p className='reference-links'>
                                                                        {el.recipe.data?.references_sources.map((item, index) => <>
                                                                            <a href={item} target='_blank' key={index}>{"Reference " + (index + 1)}</a>
                                                                            <br></br>
                                                                        </>)}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        )}

                                                        {!el.recipe.data?.nutrition_facts && (
                                                            <div className='view-img'>
                                                                <button onClick={() => getRecipeNutrition(el?.recipe?.data, i)} disabled={isLoading}>{isLoading ? 'Loading Data ...' : 'View Nutritions'}</button>
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className='mt-4'>
                                                        {
                                                            el.recipe.data.suggestions && (
                                                                <div>
                                                                    <h3>Suggestions</h3>
                                                                    <p dangerouslySetInnerHTML={{ __html: el.recipe.data.suggestions.replaceAll("\n", "<br>") }}></p>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                    <div className='mt-4'>
                                                        {
                                                            el.recipe.data.wellness_tips && (
                                                                <div>
                                                                    <h3>Wellness Tips</h3>
                                                                    <p dangerouslySetInnerHTML={{ __html: el.recipe.data.wellness_tips.replaceAll("\n", "<br>") }}></p>
                                                                </div>
                                                            )
                                                        }
                                                    </div>

                                                    <div className='mt-4'>
                                                        {
                                                            el.recipe.data.plating_creativity && (
                                                                <div>
                                                                    <h3>Plating Creativity</h3>
                                                                    {/* <p dangerouslySetInnerHTML={{ __html: el.recipe.data.plating_creativity.replaceAll("\n", "<br>") }}></p> */}

                                                                    <p>
                                                                        {el.recipe.data?.plating_creativity.map(item => <div key={item}>{item}</div>)}
                                                                    </p>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                    {!el?.images?.length ?
                                                        <div className='view-img'>
                                                            <button onClick={() => getPlatingImage(el?.recipe?.data, i)} disabled={isLoadingPlateImg}>{isLoadingPlateImg ? 'Loading Images ...' : 'View Images'}</button>
                                                        </div> :
                                                        null
                                                    }
                                                    <div className={'d-flex flex-wrap'}>
                                                        {el?.images?.length ?
                                                            el?.images?.map((image, index) => {
                                                                return (
                                                                    <div key={index} className={(window.innerWidth > 767 ? 'col-md-2 col-6 ps-0 padd mt-2 text-center' : 'col-md-2 col-6 ps-0 padd1 mt-2 text-center')} >
                                                                        <img src={image} alt='' className='plating-img' onClick={(e) => window.innerWidth > 767 ? openImage(e, image) : null} />
                                                                    </div>
                                                                )
                                                            }) :
                                                            null
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                        </Accordion.Body>
                                    </Accordion.Item>
                                )
                            })
                        }
                    </Accordion >
                    {favRecipes?.rows?.length > 0 ?
                        <div>
                            <TablePagination
                                goToPrev={goToPrev}
                                goToNext={goToNext}
                                data={favRecipes}
                            />
                        </div> :
                        null
                    }
                </div>
            </div>
            {/* ########################## Lightbox modal ####################### */}
            <Lightbox
                openBox={openBox}
                image={image}
                closeBox={() => setOpenBox(false)}
            />
        </div >

    )
}

